import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isMobileOnly } from "react-device-detect";
import { DateUtils, StringUtils } from '../../utils';
import Modal from 'react-bootstrap/Modal'
import Spinner from 'react-bootstrap/Spinner'
import config from '../../config';
import io from 'socket.io-client';

import { Routes as routes } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, InstantActions, PracticeActions } from '../../actions';
import { DownloadApp, DropdownMenu, Button, TitleBar, NavBar, Header, Line, PhoneInput, Input, ValidationCodeInput, AuthCheck, PracticeEnterpriseMessage } from  '../../components'

class InstantHomeScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      cancel_session_id: '',
      complete_session_id: '',
      invite_client_name: '',
      invite_phone_number: '',
      invite_location_name: '',
      invalid_fields: {},
      loading_invite: false,
      loading_cancel: false,
      loading_complete: false,
      display_invite_modal: false,
      display_cancel_modal: false,
      display_complete_modal: false,
      display_validation: false,
      validation_code: '',
      validation_loading: false,
      expand_getting_started: false,
      locations: [],
      providers: [],
      filter_provider_name: 'All',
      filter_location_name: 'All',
      display_tolstoy_video: false,
    }
    this.socket = null;
  }

  componentDidMount() {
    this.refreshSessions(this.props)
  }

  refreshSessions(props) {
    let token = props.user && props.user.auth && props.user.auth.token ? props.user.auth.token : '';
    let display_validation = props.instant && props.instant.validationInfo && props.instant.validationInfo.displayValidation === true ? true : false;
    let practice_id = props.practice && props.practice.practice && props.practice.practice._id ? props.practice.practice._id : '';
    if (token) {
      props.instantActions.getNonCompletedSessions(token, practice_id);
      props.practiceActions.getPracticeLocations(token, practice_id, (locations) => { this.setState({ ...this.state, locations: locations }) });
      props.practiceActions.getPracticeProviders(token, practice_id, (providers) => { this.setState({ ...this.state, providers: providers }) })
    }
    this.setState({ ...this.state, display_validation, practice_id });
    props.practiceActions.getSelectedPractice();
    props.userActions.incrementTolstoyDisplayCount();
  }

  componentWillUnmount() {
    if (this.socket) {
      this.socket.emit('end');
    }
  }

  componentDidUpdate(newProps) {

    if(newProps.practice && newProps.practice.practice && newProps.practice.practice._id !== this.state.practice_id) {
      this.refreshSessions(newProps);
    }

    let practice_id = this.props.practice && this.props.practice.practice && this.props.practice.practice._id ? this.props.practice.practice._id : '';
    if (!this.socket && practice_id) {
      this.socket = io(config.NOTIF_URL, { path: '/notifications', query: `notification=${practice_id}` });
      this.socket.on('INSTANT', (notification) => {
        if (notification.instantSession) {
          let updatedSession = notification.instantSession;
          if (updatedSession) {
            this.props.instantActions.updateSession(updatedSession);
          }
        }
      });
    }
  }

  renderOpenRoomRow = (session) => {
    let practice_city = this.getPracticeLocationCity();
    let session_id    = session._id;
    let client_name   = session.client_name;
    let client_phone  = StringUtils.displayCodePhoneNumber(session.client_phone);
    let location_name = session.location_name || practice_city;
    let provider_code = session.provider_code;
    let invited_date  = session.created_at;
    let display_date  = DateUtils.getShortMonth(invited_date) + ' ' + DateUtils.getDateNumber(invited_date) + ' | ' + DateUtils.getTime(invited_date);

    client_name       = client_name.length > 21  ? client_name.substr(0, 20) + '..' : client_name;

    let is_mobile      = isMobileOnly ? true : false;
    let flex_direction = isMobileOnly ? 'flex-container-column' : 'instant-session-row';

    return <div className={ flex_direction } style={{ justifyContent: 'space-between', padding: is_mobile ? 15 : '' }}>

      <div className='flex-container-row' style={{ justifyContent: is_mobile ? 'space-between' : 'flex-start' }}>
        <div className='flex-container-column' style={{ width: 150 }}>
          <span style={{ fontSize: 14 }}>{ client_name   }</span>
          <span style={{ fontSize: 12, marginTop: 0, color: 'grey' }}>{ client_phone  }</span>
          <span style={{ fontSize: 12, marginTop: -3, color: 'grey' }}>{ location_name }</span>
        </div>
        <div className='flex-container-column' style={{ width: 120, marginLeft: 5, justifyContent: 'flex-end', alignItems: is_mobile ? 'flex-end' : 'flex-start' }}>
          <span className='flex-container-row' style={{ alignItems: 'center' }}><span className='fas fa-user-alt' style={{ fontSize: 8, marginRight: 3, marginBottom: 1, color: '#1dc2ff' }} /><span style={{ fontSize: 12, marginTop: 0, color: 'grey' }}>{ session.provider_name }</span></span>
          <span className='flex-container-row' style={{ alignItems: 'center' }}><span className='fas fa-dot-circle'  style={{ fontSize: 8, marginRight: 3, marginBottom: 1, color: '#1dc2ff' }} /><span style={{ fontSize: 12, marginTop: -3, color: 'grey' }}>Client offline</span></span>
          <span className='flex-container-row' style={{ alignItems: 'center' }}><span className='fas fa-dot-circle'  style={{ fontSize: 8, marginTop: -3,  marginRight: 3, marginBottom: 1, color: '#1dc2ff' }} /><span style={{ fontSize: 12, marginTop: -3, color: 'grey' }}>Provider offline</span></span>
        </div>
      </div>

      <div className='flex-container-row' style={{ justifyContent: 'space-between', marginTop: is_mobile ? 15 : '' }}>
        <div className='flex-container-column' style={{ width: 60, marginLeft: is_mobile ? 0 : 15, justifyContent: 'flex-end' }}>
          <span style={{ fontSize: 12, marginTop: 0, color: 'grey' }}>Join Code</span>
          <span style={{ fontSize: 12, marginTop: -3, color: '#1dc2ff' }}>{ provider_code }</span>
        </div>
        <div className='flex-container-column' style={{ marginLeft: 15, justifyContent: 'space-between', alignItems: 'flex-end' }}>
          <span style={{ fontSize: 10, marginRight: 2, color: '#8a8a8a' }}>{ display_date }</span>
          <div className='flex-container-row'>
            <span className='instant-cancel-button'
                  style={{ marginRight: 10 }}
                  onClick={ () => {
                    this.setState({ ...this.state, display_cancel_modal: true, cancel_session_id: session_id })
                  }}>
                  <span className='fas fa-trash-alt' style={{ fontSize: 16, color: '#1dc2ff' }} />
            </span>
            <a className='instant-join-session-button' href={ config.FRONT_END_URL + '/vs/' + provider_code } target='_blank'>
              <span className='fas fa-video' style={{ fontSize: 12, marginRight: 8, color: 'white' }} />Join Session
            </a>
          </div>
        </div>
      </div>

    </div>
  }

  renderOpenRoomsSection = (status_dict, sessions_dict) => {
    let status_ids_dict = status_dict || {};
    let all_sesh_dict   = sessions_dict || {};
    let session_ids_arr = status_ids_dict['INVITED'] || [];
    let name_filter     = this.state.filter_provider_name || '';
    let loc_filter      = this.state.filter_location_name || '';

    let session_rows = session_ids_arr.map((session_id, index) => {
      let session = all_sesh_dict[session_id] || null;
      if (session) {
        let provider_name = session.provider_name || '';
        let location_name = session.location_name || '';
        let display       = true;
            display       = name_filter && name_filter !== 'All' && name_filter !== provider_name ? false : display;
            display       = loc_filter  && loc_filter  !== 'All' && loc_filter  !== location_name ? false : display;

        if (!display) {
          return false;
        }

        return <div className='instant-session-column' key={session_id}>
          { this.renderOpenRoomRow(session) }
          <Line style={{ backgroundColor: '#f5f5f5' }} />
        </div>
      }
    }).filter((row) => { return row });

    let display_no_sessions = session_rows.length === 0 ? true : false;
    let header_button_title = display_no_sessions ? '' : 'Start Session';
    let container_width     = isMobileOnly ? 360 : 565;
    return <div className='standard-container' style={{ width: container_width, minWidth: container_width, maxWidth: container_width }}>
      <Header title='Open Rooms'
              icon='fas fa-chalkboard-teacher'
              second_btn_title={ header_button_title }
              second_btn_action={ () => { this.setState({ ...this.state, display_invite_modal: true }) }} />
      { display_no_sessions ? <div className='flex-container-column' style={{ paddingTop: 30, paddingBottom: 30, color: 'grey', fontSize: 14, justifyContent: 'center', alignItems: 'center' }}>
                                <span style={{ marginBottom: 8 }}>There are no Open Rooms. Start one by Inviting a Client.</span>
                                <div className='instant-join-session-button' onClick={ () => { this.setState({ ...this.state, display_invite_modal: true }) }}>
                                  <span className='fas fa-plus-circle' style={{ fontSize: 16, marginRight: 5 }}/>
                                  <span style={{ fontWeight: 'bold', fontSize: 14 }}>Start Session</span>
                                </div>
                              </div>
                            : session_rows }
    </div>
  }

  renderActiveSessionRow = (session) => {
    let practice_city = this.getPracticeLocationCity();
    let session_id    = session._id;
    let client_name   = session.client_name;
    let client_phone  = StringUtils.displayCodePhoneNumber(session.client_phone);
    let provider_name = session.provider_name || '';
    let location_name = session.location_name || practice_city;
    let provider_code = session.provider_code;

    let invited_date  = session.created_at;
    let display_date  = DateUtils.getShortMonth(invited_date) + ' ' + DateUtils.getDateNumber(invited_date) + ' | ' + DateUtils.getTime(invited_date);

    let provider_connected  = session.is_provider_connected || false;
    let client_connected    = session.is_client_connected   || false;
    let provider_icon_color = provider_connected ? '#66D56F' : '#1dc2ff';
    let client_icon_color   = client_connected   ? '#66D56F' : '#1dc2ff';
    let provider_text_color = provider_connected ? '#66D56F' : 'grey';
    let client_text_color   = client_connected   ? '#66D56F' : 'grey';
    let provider_text       = provider_connected && provider_name  ? provider_name : 'Provider offline';
        provider_text       = provider_connected && !provider_name ? 'Provider online' : provider_text;
    let client_text         = client_connected   && client_name    ? client_name : 'Client offline';
        client_text         = client_connected   && !client_name   ? 'Client online' : client_text;

    provider_text = provider_text.length > 16  ? provider_text.substr(0, 16) + '..' : provider_text;
    client_text   = client_text.length   > 16  ? client_text.substr(0, 16)   + '..' : client_text;
    client_name   = client_name.length   > 21  ? client_name.substr(0, 20)   + '..' : client_name;

    let is_mobile      = isMobileOnly ? true : false;
    let flex_direction = isMobileOnly ? 'flex-container-column' : 'instant-session-row';

    return <div className={ flex_direction } style={{ padding: is_mobile ? 15 : '' }}>

      <div className='flex-container-row' style={{ justifyContent: 'space-between' }}>
        <div className='flex-container-column' style={{  }}>
          <span style={{ fontSize: 14 }}>{ client_name   }</span>
          <span style={{ fontSize: 12, marginTop: 0, color: 'grey' }}>{ client_phone  }</span>
          <span style={{ fontSize: 12, marginTop: -3, color: 'grey' }}>{ location_name }</span>
        </div>
        <div className='flex-container-column' style={{ width: 120, marginLeft: 5, justifyContent: 'flex-end', alignItems: is_mobile ? 'flex-end' : 'flex-start' }}>
          <span className='flex-container-row' style={{ alignItems: 'center' }}><span className='fas fa-dot-circle' style={{ fontSize: 8, marginRight: 3, marginBottom: 1, color: client_icon_color }} /><span style={{ fontSize: 12, marginTop: 0, color: client_text_color }}>{ client_text }</span></span>
          <span className='flex-container-row' style={{ alignItems: 'center' }}><span className='fas fa-dot-circle' style={{ fontSize: 8, marginTop: -3, marginRight: 3, marginBottom: 1, color: provider_icon_color }} /><span style={{ fontSize: 12, marginTop: -3, color: provider_text_color }}>{ provider_text }</span></span>
        </div>
      </div>

      <div className='flex-container-row' style={ is_mobile ? { justifyContent: 'space-between', marginTop: 10 } : {} }>
          <div className='flex-container-column' style={{ width: 60, marginLeft: isMobileOnly? 0 : 15, justifyContent: 'flex-end' }}>
            <span style={{ fontSize: 12, marginTop: 0, color: 'grey' }}>Join Code</span>
            <span style={{ fontSize: 12, marginTop: -3, color: '#1dc2ff' }}>{ provider_code }</span>
          </div>

          <div className='flex-container-column' style={{ marginLeft: 10, justifyContent: 'space-between', alignItems: 'flex-end' }}>
            <span style={{ fontSize: 10, marginRight: 2, color: '#8a8a8a' }}>{ display_date }</span>
            <div className='flex-container-row'>
              <span className='instant-join-session-button'
                    style={{ marginRight: 5 }}
                    onClick={ () => {
                      this.setState({ ...this.state, display_complete_modal: true, complete_session_id: session_id });
                    }}>
                    <span style={{ fontSize: 12, fontWeight: 'bold' }}>End</span>
              </span>
              <a className='instant-join-session-button' href={ config.FRONT_END_URL + '/vs/' + provider_code } target='_blank'>
                <span className='fas fa-video' style={{ fontSize: 12, marginRight: 8, color: 'white' }} />Join Session
              </a>
            </div>
          </div>
        </div>

    </div>
  }

  renderActiveSessionsSection = (status_dict, sessions_dict) => {
    let status_ids_dict = status_dict   || {};
    let all_sesh_dict   = sessions_dict || {};
    let session_ids_arr = status_ids_dict['IN_PROGRESS'] || [];

    let session_rows = session_ids_arr.map((session_id, index) => {
      let session = all_sesh_dict[session_id] || null;
      if (session) {
        return <div className='flex-container-column' key={session_id}>
          { this.renderActiveSessionRow(session) }
          <Line style={{ backgroundColor: '#f5f5f5' }} />
        </div>
      }
    }).filter((row) => { return row });

    let display_no_sessions = session_rows.length === 0 ? true : false;
    let container_width     = isMobileOnly ? 360 : 565;

    return <div className='standard-container' style={{ width: container_width, minWidth: container_width, maxWidth: container_width }}>
      <Header title='Active Sessions' icon='fas fa-user-check' />
      { display_no_sessions ? <div style={{ textAlign: 'center', color: 'grey', fontSize: 14, paddingTop: 50, paddingBottom: 50 }}>There are no Active Sessions</div> : session_rows }
    </div>
  }

  renderGettingStarted = () => {
    let section_height    = this.state.expand_getting_started ? 760 : 170;
    let is_mobile_browser = isMobileOnly;
    let inner_width       = window.innerWidth
    let container_style   = { minHeight: section_height, maxHeight: section_height, height: section_height, alignSelf: 'center', marginBottom: -5, marginTop: 10, maxWidth: 1178, width: 1178, minWidth: 1178, padding: 15 }

    let tolstoy_count     = this.props.user && this.props.user.diplayedTolstoyCount ? this.props.user.diplayedTolstoyCount : null;
    let display_tolstoy   = (this.props.user.diplayedTolstoyCount && (this.props.user.diplayedTolstoyCount === 0 || this.props.user.diplayedTolstoyCount === 1 || this.props.user.diplayedTolstoyCount === 2 || this.props.user.diplayedTolstoyCount === 3)) || this.state.display_tolstoy_video;

    let top_section    = <div className='flex-container-row' style={{ justifyContent: 'space-between' }}>
                            <div className='flex-container-column'>
                              <span style={{ fontSize: 16, fontWeight: 'bold', color: '#575757', marginBottom: 5 }}>Starting a Video Session with TeleTails Instant</span>
                              <span style={{ fontSize: 13, color: 'grey' }}>1. Click the <span style={{ fontWeight: 'bold', color: '#575757' }}>“Start Session”</span> button.</span>
                              <span style={{ fontSize: 13, color: 'grey' }}>2. Enter a client’s name and phone number to send an invitation link via text message.</span>
                              <span style={{ fontSize: 13, color: 'grey' }}>3. The session will show up under “Active Sessions” once your client follows the link and is online. Click “Join Session” to connect.</span>
                            </div>
                            <div className='flex-container-column' style={{ width: 240, marginLeft: 10, justifyContent: 'flex-end', alignItems: 'flex-end', paddingBottom: 0 }}>
                              <div className='button-default'
                                   style={{ padding: 18, paddingRight: 25, paddingLeft: 25, borderRadius: 5, textAlign: 'center', width: 200 }}
                                   onClick={ () => {
                                     this.setState({ ...this.state, display_invite_modal: true });
                                   }}>
                                <span style={{ color: 'white', fontSize: 15, letterSpacing: 0.8 }}>Start Session</span>
                              </div>
                            </div>
                          </div>

    if (is_mobile_browser) {
      container_style = { alignSelf: 'center', marginBottom: -5, marginTop: 10, padding: 20, width: 360 }
      top_section = <div className='flex-container-column' style={{ }}>
                        <div className='flex-container-column' style={{ marginBottom: 15 }}>
                          <span style={{ fontSize: 16, fontWeight: 'bold', color: '#575757', marginBottom: 10 }}>Starting a Video Session with TeleTails Instant</span>
                          <span style={{ fontSize: 13, color: 'grey', marginBottom: 5 }}>1. Click the <span style={{ fontWeight: 'bold', color: '#575757' }}>“Start Session”</span> button.</span>
                          <span style={{ fontSize: 13, color: 'grey', marginBottom: 5 }}>2. Enter a client’s name and phone number to send an invitation link via text message.</span>
                          <span style={{ fontSize: 13, color: 'grey', marginBottom: 5 }}>3. The session will show up under “Active Sessions” once your client follows the link and is online. Click “Join Session” to connect.</span>
                        </div>
                        <div className='flex-container-column' style={{ justifyContent: 'flex-end', alignItems: 'center', paddingBottom: 0 }}>
                          <div className='button-default'
                               style={{ padding: 18, paddingRight: 25, paddingLeft: 25, borderRadius: 5, textAlign: 'center', width: 200 }}
                               onClick={ () => {
                                 this.setState({ ...this.state, display_invite_modal: true });
                               }}>
                            <span style={{ color: 'white', fontSize: 15, letterSpacing: 0.8 }}>Start Session</span>
                          </div>
                        </div>
                      </div>
    }

    return <div className='get-started-container' style={container_style}>
      { top_section }
      <Line style={{ marginTop: 15, marginBottom: 15 }} />
      { this.state.expand_getting_started ? null : <div className='flex-container-row' style={{ backgroundColor: 'white', marginTop: -8, justifyContent: 'space-between' }}>
                                                     <span className='button-clear-blue' onClick={ () => { this.setState({ ...this.state, expand_getting_started: true }) }}>More Information</span>
                                                     <span className='button-clear-blue flex-container-row' onClick={ () => { this.setState({ ...this.state, display_tolstoy_video: true })  }}>Learn how Instant works</span>
                                                   </div>
                                                   }
      { this.state.expand_getting_started
      ? <div className='flex-container-column'>
          <div className='flex-container-row'>
            <span style={{ fontSize: 13, color: 'grey' }}>A great way to start is to try a sample session with your team. Hit the blue “Start Session” button to begin. Don’t worry if you don’t have someone to invite at the moment; just use your own phone number!</span>
            <span className='fas fa-times button-clear-blue' style={{ height: 30 }} onClick={ () => { this.setState({ ...this.state, expand_getting_started: false }) }}></span>
          </div>
          <span style={{ fontSize: 13, color: '#575757', fontWeight: 'bold', marginTop: 15, marginBottom: 10 }}>Please watch our instructional video, or follow the step-by-step guide:</span>
          <iframe width="300" height="260" src="https://www.youtube.com/embed/rBqcMWpITlE" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          <span style={{ fontSize: 13, fontWeight: 'bold', color: '#575757', marginTop: 20 }}>Step 1) Invite your client by entering their name and phone number.</span>
          <span style={{ fontSize: 13, color: 'grey', marginTop: 3 }}>Select “Start Session.” Enter the client’s name and phone number. Choosing a practice location is optional, but it’s helpful if you have multiple clinic locations using one account.</span>
          <span style={{ fontSize: 13, fontWeight: 'bold', color: '#575757', marginTop: 15 }}>Step 2) Wait for the client to join the session.</span>
          <span style={{ fontSize: 13, color: 'grey', marginTop: 3 }}>Your client will have received a text message from TeleTails with an invitation code and a link that will bring them directly to a video session.</span>
          <span style={{ fontSize: 13, fontWeight: 'bold', color: '#575757', marginTop: 15 }}>Step 3) From the Active Sessions window, select “Join Session” to connect.</span>
          <span style={{ fontSize: 13, color: 'grey', marginTop: 3 }}>Once your client is ready, you will see a green dot next to the clients name in the Active Sessions window. This indicates that they are now online. Select “Join Session” to connect and enter your name.</span>
          <span style={{ fontSize: 13, fontWeight: 'bold', color: '#575757', marginTop: 15 }}>Step 4) (Optional) Once your session has been completed, you can select the “End” button to archive the session.</span>
          <span style={{ fontSize: 13, color: 'grey', marginTop: 3 }}>Sessions will be auto-archived overnight. If you do so immediately, it will reduce the potential for teammate confusion in case they were to see the active session on their dashboard.</span>
        </div>
      : null }
    </div>
  }

  renderDownloadAppSection = () => {
    return <DownloadApp />
  }

  renderContentContainers = () => {
    let status_dict   = this.props.instant  && this.props.instant.sessionsStatusDict ? this.props.instant.sessionsStatusDict : {};
    let sessions_dict = this.props.instant  && this.props.instant.instantSessions    ? this.props.instant.instantSessions    : {};
    let practice      = this.props.practice && this.props.practice.practice          ? this.props.practice.practice          : null;

    let tolstoy_count     = this.props.user && this.props.user.diplayedTolstoyCount ? this.props.user.diplayedTolstoyCount : null;
    let display_tolstoy   = (this.props.user.diplayedTolstoyCount && (this.props.user.diplayedTolstoyCount === 0 || this.props.user.diplayedTolstoyCount === 1 || this.props.user.diplayedTolstoyCount === 2 || this.props.user.diplayedTolstoyCount === 3)) || this.state.display_tolstoy_video;
    let display_menu_bar  = isMobileOnly ? false : true;
    let side_margins      = isMobileOnly ? 0     : 10;
    // if (isMobileOnly) {
    //   return this.renderDownloadAppSection();
    // }

    return <div className='flex-container-column' style={{ width: '100%' }}>
      { display_tolstoy ?  <div className='flex-container-column' style={{ alignItems: 'center' }}>
                            <div style={{ lineHeight: 0, overflow: 'hidden', height: '100%', width: '100%' }}>
                              <iframe src="https://player.gotolstoy.com/gthp1uolsy8i8?host"
                                      style={{ width: '100%', height: 540 }}
                                      scrolling="no" frameborder="0" allow="autoplay *">
                              </iframe>
                             </div>
                             <span className='button-clear-blue flex-container-row'
                                   style={{ alignItems: 'center', marginTop: 10 }}
                                   onClick={ () => {
                                     this.props.userActions.incrementTolstoyDisplayCount(true);
                                     this.setState({ ...this.state, display_tolstoy_video: false });
                                   }}><span className='fas fa-times-circle'  style={{ marginRight: 5, fontSize: 18, marginBottom: 1 }}/>Close Video</span>
                            </div>: false }
      { this.renderGettingStarted() }
      { display_menu_bar ? this.renderMenuBar() : null }
      <div className="flex-container screen-main-content">
          <div className="flex-container-column" style={{ alignItems: 'center', marginRight: side_margins, marginTop: 20 }}>
            <div className='flex-container-row'>
              { this.renderOpenRoomsSection(status_dict, sessions_dict) }
            </div>
            <PracticeEnterpriseMessage practice={practice} practiceActions={this.props.practiceActions} />
          </div>
          <div className="flex-container-column" style={{ alignItems: 'center', marginLeft: side_margins, marginTop: isMobileOnly ? 0 : 20 }}>
            <div className='flex-container-row'>
              { this.renderActiveSessionsSection(status_dict, sessions_dict) }
            </div>
          </div>
      </div>
    </div>
  }

  renderValidation = () => {
    let validation_code = this.state.validation_code;
    let loading         = this.state.validation_loading;

    return <div className="flex-container flex-container-column flex-center-align">
      <div className='instant-sign-in-container flex-container-column' style={{ height: 250 }}>
        <div className='flex-container-row' style={{ justifyContent: 'space-between', padding: 10, paddingLeft: 15, paddingRight: 15, alignItems: 'center' }}>
          <span className='fas fa-arrow-circle-left instant-back-button'
                style={{ fontSize: 30 }}
                onClick={ () => {
                  this.props.userActions.signOut();
                }} />
          <div className='flex-container-column' style={{ alignItems: 'center' }}>
            <span style={{ fontWeight: 'bold', fontSize: 22 }}>Account Validation</span>
            <span style={{ width: 210, height: 2, borderRadius: 2, backgroundColor: '#1dc2ff' }}></span>
            <span style={{ fontSize: 12, color: '#1dc2ff' }}>Please check your email for a validation code</span>
          </div>
          <span className='fas fa-arrow-circle-left' style={{ fontSize: 30, color: 'white' }}></span>
        </div>

        <div className='flex-container-column' style={{ alignItems: 'center', marginTop: 15 }}>
          <span style={{ fontSize: 12, color: 'grey' }}>Enter Code</span>
          <ValidationCodeInput
            value={validation_code}
            style={{ width: 100, padding: 0, fontSize: 20, textAlign: 'center', marginBottom: 5 }}
            onChange={ (code) => { this.setState({ ...this.state, validation_code: code }) }}
            completeAction={ (code) => {
              this.validationAction(code);
            }}
          />
          <div className='instant-join-session-button'
               onClick={ () => {
                 this.validationAction(this.state.validation_code);
               }}>
            { loading ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white', marginRight: 8 }} />
                      : <span className='fas fa-check-circle' style={{ fontSize: 16, marginRight: 8 }}/> }
            <span style={{ fontWeight: 'bold', fontSize: 14 }}>Validate Account</span>
          </div>
          <div style={{ marginTop: 40 }}>
            <span style={{ fontSize: 12, color: 'grey'}}>Didn't receive a code?
            <span style={{ color: '#1dc2ff', marginLeft: 5 }}
                  className='instant-back-button'
                  onClick={ () => {
                    this.resendEmail();
                  }}>Resend Email</span>
          </span>
          </div>
        </div>

      </div>
    </div>
  }

  renderMenuBar = () => {
    let status_dict   = this.props.instant && this.props.instant.sessionsStatusDict ? this.props.instant.sessionsStatusDict : {};
    let sessions_dict = this.props.instant && this.props.instant.instantSessions    ? this.props.instant.instantSessions    : {};

    let status_ids_dict = status_dict   || {};
    let all_sesh_dict   = sessions_dict || {};
    let invited_ids     = status_ids_dict['INVITED']     || [];
    let progress_ids    = status_ids_dict['IN_PROGRESS'] || [];
    let session_ids_arr = [ ...invited_ids, ...progress_ids ]

    let sessions        = session_ids_arr.map((session_id) => {
                            if (all_sesh_dict && all_sesh_dict[session_id]) {
                              return all_sesh_dict[session_id];
                            }
                          })

    return <div className='flex-container-row' style={{ maxWidth: 1178, width: 1178, minWidth: 1178, alignSelf: 'center', marginTop: 24, justifyContent: 'space-between' }}>
      <div className='standard-container' style={{ margin: 0, padding: 10, maxWidth: '100%', minWidth: '100%', width: '100%', flex: 1 }}>
        <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'center' }}>

          <div className='flex-container-row' style={{ alignItems: 'center' }}>
            <div className='flex-container-column' style={{ marginRight: 15 }}>
              <span style={{ fontSize: 10, color: '#1dc2ff', marginBottom: 5 }}><span className='fas fa-sliders-h' style={{ marginRight: 5 }} />PROVIDER</span>
              { this.renderProviderDropdown(sessions) }
            </div>
            <div className='flex-container-column'>
            <span style={{ fontSize: 10, color: '#1dc2ff', marginBottom: 5 }}><span className='fas fa-sliders-h' style={{ marginRight: 5 }} />LOCATION</span>
              { this.renderLocationDropdown(sessions) }
            </div>
          </div>

          <div className='flex-container-row' style={{ alignItems: 'center' }}>
            <div style={{ backgroundColor: '#e7e7e7', width: 1, marginRight: 10, height: 40 }}></div>
            <Button value='View Archived Sessions'
                    className='button-clear-blue'
                    style={{ color: '#1dc2ff', marginRight: 15 }}
                    onClick={ () => {
                      this.props.instantActions.openCompletedSessions();
                    }}/>
            <Button value='FAQs'
                    className='button-clear-blue'
                    style={{ color: '#1dc2ff' }}
                    onClick={ () => {
                      this.props.instantActions.openFaqScreen();
                    }} />
          </div>

        </div>
      </div>
    </div>
  }

  renderProviderDropdown = (sessions) => {

    let provider_names_dict = {};

    sessions.forEach((session) => {
      let provider_name = session.provider_name;
      if (provider_name) {
        provider_names_dict[provider_name] = true;
      }
    });

    let provider_names = Object.keys(provider_names_dict);
    let filter_options = [ 'All', ...provider_names ];
    let selection_rows = filter_options.map((option_str) => {
      return <span className='instant-menu-item' key={option_str} onClick={ () => { this.setState({ ...this.state, filter_provider_name: option_str })}}>{ option_str }</span>
    })

    return <DropdownMenu className={ `instant-providers-dropdown` }
                         style={{ paddingRight: 10 }}
                         toggle_element={
                           <div className='flex-container-row' style={{  flex: 1, alignItems: 'center' }}>
                             <span style={{ flex: 1 }}>{ this.state.filter_provider_name }</span>
                             <span className='fas fa-chevron-circle-down' style={{ color: '#1dc2ff', fontSize: 16 }} />
                           </div>
                         }
                         menu_style={{ }}
                         menu_element={
                          <div className='flex-container-column instant-menu-container' style={{  }}>
                            { selection_rows }
                          </div>
                         }
                       />
  }

  renderLocationDropdown = (sessions) => {
    let location_names_dict = {};

    sessions.forEach((session) => {
      let location_name = session.location_name;
      if (location_name) {
        location_names_dict[location_name] = true;
      }
    });

    let location_names = Object.keys(location_names_dict);
    let filter_options = [ 'All', ...location_names ];

    let selection_rows = filter_options.map((option_str) => {
      return <span className='instant-menu-item' key={option_str} onClick={ () => { this.setState({ ...this.state, filter_location_name: option_str })}}>{ option_str }</span>
    })

    return <DropdownMenu className={ `instant-providers-dropdown` }
                         style={{ paddingRight: 10 }}
                         toggle_element={
                           <div className='flex-container-row' style={{  flex: 1, alignItems: 'center' }}>
                             <span style={{ flex: 1 }}>{ this.state.filter_location_name }</span>
                             <span className='fas fa-chevron-circle-down' style={{ color: '#1dc2ff', fontSize: 16 }} />
                           </div>
                         }
                         menu_style={{ }}
                         menu_element={
                          <div className='flex-container-column instant-menu-container' style={{  }}>
                            { selection_rows }
                          </div>
                         }
                       />
  }

  render() {

    let display_validation = this.props.instant && this.props.instant.validationInfo && this.props.instant.validationInfo.displayValidation === true ? true : false;

    if (display_validation) {
      return this.renderValidation();
    }

    return (
      <div className="flex-container flex-container-column flex-center-align">
        { display_validation ? null : <AuthCheck user={this.props.user} userActions={this.props.userActions} /> }
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <NavBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          selectedTab={'my_account'}
          practice={this.props.practice.practice}
          currentRoute={routes.INSTANT_HOME}
          notifications={this.props.notifications}
        />
        { this.renderContentContainers() }
        { this.renderInviteModal()       }
        { this.renderCancelModal()       }
        { this.renderCompleteModal()     }
      </div>
    );
  }

  renderCompleteModal = (session_id) => {
    let display_modal = this.state.display_complete_modal;
    let loading       = this.state.loading_complete;

    return <Modal show={display_modal} onHide={ () => { this.clearCompleteModal() }}>
      <div className='flex-container-column' style={{ padding: 15 }}>
        <div className='flex-container-row' style={{ marginBottom: 15, alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontWeight: 'bold', fontSize: 16, marginTop: 2, color: '#575757' }}>Mark Session as Completed</span>
          <span className='instant-cancel-button' onClick={ () => { this.clearCompleteModal() }}>
            <span className='fas fa-times' style={{ fontSize: 16, color: '#1dc2ff' }} />
          </span>
        </div>
        <div style={{ marginBottom: 10 }}>
          <span style={{ fontSize: 14, color: 'grey' }}>Are you sure you would like to mark this session as Completed? The client will receive a message alerting them of the completion.</span>
        </div>
        <div className='flex-container-row' style={{ marginTop: 10, justifyContent: 'flex-end' }}>
          <div className='instant-join-session-button'
               onClick={ () => {
                 let token      = this.props.user.auth.token;
                 let session_id = this.state.complete_session_id;
                 let practice_id = this.props.practice && this.props.practice.practice && this.props.practice.practice._id ? this.props.practice.practice._id : '';

                 this.setState({ ...this.state, loading_complete: true });
                 this.props.instantActions.completeSession(token, practice_id, session_id, this.clearCompleteModal);
               }}>
            { loading ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white', marginRight: 8 }} />
                      : <span className='fas fa-check' style={{ fontSize: 16, marginRight: 8 }}/> }
            <span style={{ fontWeight: 'bold', fontSize: 14 }}>Complete Session</span>
          </div>
        </div>
      </div>
    </Modal>
  }

  renderCancelModal = (session_id) => {
    let display_modal = this.state.display_cancel_modal;
    let loading       = this.state.loading_cancel;

    return <Modal show={display_modal} onHide={ () => { this.clearCancelModal() }}>
      <div className='flex-container-column' style={{ padding: 15 }}>
        <div className='flex-container-row' style={{ marginBottom: 15, alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontWeight: 'bold', fontSize: 16, marginTop: 2, color: '#575757' }}>Cancel Session</span>
          <span className='instant-cancel-button' onClick={ () => { this.clearCancelModal() }}>
            <span className='fas fa-times' style={{ fontSize: 16, color: '#1dc2ff' }} />
          </span>
        </div>
        <div style={{ marginBottom: 10 }}>
          <span style={{ fontSize: 14, color: 'grey' }}>Are you sure you would like to cancel this session? The client will receive a message alerting them of the cancellation.</span>
        </div>
        <div className='flex-container-row' style={{ marginTop: 10, justifyContent: 'flex-end' }}>
          <div className='instant-join-session-button'
               onClick={ () => {
                 let token       = this.props.user.auth.token;
                 let session_id  = this.state.cancel_session_id;
                 let practice_id = this.props.practice && this.props.practice.practice && this.props.practice.practice._id ? this.props.practice.practice._id : '';

                 this.setState({ ...this.state, loading_cancel: true });
                 this.props.instantActions.cancelSession(token, practice_id, session_id, this.clearCancelModal);
               }}>
            { loading ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white', marginRight: 8 }} />
                      : <span className='fas fa-trash-alt' style={{ fontSize: 16, marginRight: 8 }}/> }
            <span style={{ fontWeight: 'bold', fontSize: 14 }}>Cancel Session</span>
          </div>
        </div>
      </div>
    </Modal>
  }

  renderInviteModal = () => {
    let display_modal  = this.state.display_invite_modal;
    let loading        = this.state.loading_invite;
    let flex_direction = isMobileOnly ? 'flex-container-column' : 'flex-container-row';

    return <Modal show={display_modal} onHide={ () => { this.clearInviteModal() }}>
      <div className='flex-container-column' style={{ padding: 15 }}>
        <div className='flex-container-row' style={{ marginBottom: 15, alignItems: 'flex-start', justifyContent: 'space-between' }}>
          <div className='flex-container-column' style={{ paddingRight: 15 }}>
            <span style={{ fontWeight: 'bold', fontSize: 16, marginTop: 2, color: '#575757' }}>Start Session</span>
            <span style={{ fontSize: 13, color: 'grey' }}>Add your client’s name and phone number. Select “Send Invitation” to invite your client via text message. Once your client joins, the session will show up as being joinable under your Active Sessions window.</span>
          </div>
          <span className='instant-cancel-button' onClick={ () => { this.clearInviteModal() }}>
            <span className='fas fa-times' style={{ fontSize: 16, color: '#1dc2ff' }} />
          </span>
        </div>

        <div className={ flex_direction } style={{ marginBottom: 10, alignItems: 'center' }}>

        { this.renderInviteProviderDropdown() }
        { this.renderInviteLocationDropdown() }

        { /* <Input placeholder="Practice Location (Optional)"
                 value={this.state.invite_location_name}
                 className='instant-input-default'
                 style={{ flex: 1, height: 34 }}
                 onChange={ (event) => { this.setState({ ...this.state, invite_location_name: event.target.value }) }}
                /> */ }
        </div>
        <div className={ flex_direction } style={{ alignItems: 'center' }}>
          <Input placeholder="Client Name"
                 value={this.state.invite_client_name}
                 className='instant-input-default'
                 invalid={this.state.invalid_fields && this.state.invalid_fields['invite_client_name']}
                 style={{ flex: isMobileOnly ? '' : 1, width: 250, marginRight: isMobileOnly ? 0 : 10, height: 34, marginBottom: isMobileOnly ? 10 : 0 }}
                 onChange={ (event) => { this.setState({ ...this.state, invite_client_name: event.target.value }) }}
                />
          <PhoneInput value={this.state.invite_phone_number}
                      style={{ fontSize: 13 }}
                      containerStyle={ isMobileOnly ? { width: 250 } : {}}
                      invalid={this.state.invalid_fields && this.state.invalid_fields['invite_phone_number']}
                      onChange={ (phone_number) => { this.setState({ ...this.state, invite_phone_number: phone_number }) }} />
        </div>
        <div className='flex-container-row' style={{ marginTop: isMobileOnly ? 20 : 10, justifyContent: 'flex-end' }}>
          <div className='instant-join-session-button'
               onClick={ () => {

                 let practice_id = this.props.practice && this.props.practice.practice && this.props.practice.practice._id ? this.props.practice.practice._id : '';
                 let invite_data = {
                   client_name: this.state.invite_client_name,
                   client_phone: this.state.invite_phone_number,
                   location_name: this.state.invite_location_name,
                   provider_name: this.state.invite_provider_name,
                   practice_id: practice_id,
                 }

                 let fields     = {};
                 fields['invite_client_name']  = this.state.invite_client_name  === '' ? true : false;
                 fields['invite_phone_number'] = this.state.invite_phone_number === '' ? true : false;

                 if (fields['invite_client_name'] || fields['invite_phone_number']) {
                   this.setState({ ...this.state, invalid_fields: fields });
                 } else {
                   let token = this.props.user.auth.token;
                   this.setState({ ...this.state, invalid_fields: {}, loading_invite: true });
                   this.props.instantActions.sendInstantInvite(token, invite_data, this.clearInviteModal);
                 }

               }}>
            { loading ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white', marginRight: 8 }} />
                      : <span className='fas fa-paper-plane' style={{ fontSize: 16, marginRight: 8 }}/> }
            <span style={{ fontWeight: 'bold', fontSize: 14 }}>Send Invitation</span>
          </div>
        </div>
      </div>
    </Modal>
  }

  renderInviteProviderDropdown = () => {
    let provider_names = this.getProviderNames();
    let selected_provider_name = this.state.invite_provider_name || 'Select Provider';
    let width          = isMobileOnly ? 250 : 247;

    let provider_name_rows = provider_names.map((name) => {
      return <span className='instant-menu-item'
                   onClick={ () => {
                     this.setState({ ...this.state, invite_provider_name: name });
                   }}>{ name }</span>
    })

    return <DropdownMenu className={ `instant-providers-dropdown` }
                         style={{ width: width, marginRight: isMobileOnly ? 0 : 10, paddingRight: 10 }}
                         toggle_element={
                           <div className='flex-container-row' style={{  flex: 1, alignItems: 'center' }}>
                             <span style={{ flex: 1 }}>{ selected_provider_name }</span>
                             <span className='fas fa-chevron-circle-down' style={{ color: '#1dc2ff', fontSize: 16 }} />
                           </div>
                         }
                         menu_style={{ }}
                         menu_element={
                          <div className='flex-container-column instant-menu-container' style={{ width: 247 }}>
                            { provider_name_rows }
                          </div>
                         }
                       />
  }

  renderInviteLocationDropdown = () => {
    let location_names = this.getLocationNames();
    let selected_location_name = this.state.invite_location_name || 'Select Location';
    let width          = isMobileOnly ? 250 : 210;
    let margin_top     = isMobileOnly ? 10  :   0;

    let location_name_rows = location_names.map((name) => {
      return <span className='instant-menu-item'
                   onClick={ () => {
                     this.setState({ ...this.state, invite_location_name: name });
                   }}>{ name }</span>
    })

    return <DropdownMenu className={ `instant-providers-dropdown` }
                         style={{ width: width, paddingRight: 10, marginTop: margin_top }}
                         toggle_element={
                           <div className='flex-container-row' style={{  flex: 1, alignItems: 'center' }}>
                             <span style={{ flex: 1 }}>{ selected_location_name }</span>
                             <span className='fas fa-chevron-circle-down' style={{ color: '#1dc2ff', fontSize: 16 }} />
                           </div>
                         }
                         menu_style={{ }}
                         menu_element={
                          <div className='flex-container-column instant-menu-container' style={{ width: 210 }}>
                            { location_name_rows }
                          </div>
                         }
                       />
  }

  getLocationNames = () => {
    let locations = this.state.locations || [];
    let names     = [];

    locations.forEach((location) => {
      let location_name = location.name || location.street_address;
      names.push(location_name);
    });

    return names;
  }

  getProviderNames = () => {
    let providers = this.state.providers || [];
    let names     = [];

    providers.forEach((provider) => {
      let provider_name = StringUtils.displayName(provider);
      names.push(provider_name);
    });

    return names;
  }

  validationAction = (code) => {
    let email = this.props.instant && this.props.instant.validationInfo && this.props.instant.validationInfo.em ? this.props.instant.validationInfo.em : '';
    let pwd   = this.props.instant && this.props.instant.validationInfo && this.props.instant.validationInfo.pw ? this.props.instant.validationInfo.pw : '';

    this.props.instantActions.instantLogin(email, pwd, code);
    this.setState({ ...this.state, validation_loading: true, validation_code: code });
  }

  resendEmail = () => {
    let email = this.props.instant && this.props.instant.validationInfo && this.props.instant.validationInfo.em ? this.props.instant.validationInfo.em : '';
    this.props.instantActions.resendVerificationCode(email);
  }

  getPracticeLocationCity = () => {
    let city = this.props.instant && this.props.instant.instantUserPracticeLocation && this.props.instant.instantUserPracticeLocation.city ? this.props.instant.instantUserPracticeLocation.city : '';
    return city;
  }

  clearInviteModal = () => {
    this.setState({ ...this.state,
      display_invite_modal: false,
      invite_client_name: '',
      invite_phone_number: '',
      invite_location_name: '',
      invalid_fields: {},
      loading_invite: false,
    });
  }

  clearCancelModal = () => {
    this.setState({ ...this.state,
      display_cancel_modal: false,
      loading_cancel: false,
      cancel_session_id: '',
    });
  }

  clearCompleteModal = () => {
    this.setState({ ...this.state,
      display_complete_modal: false,
      loading_complete: false,
      complete_session_id: '',
    });
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    loading: state.loading,
    instant: state.instant,
    practice: state.practice,
    notifications: state.notifications,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    instantActions: bindActionCreators(
     { ...InstantActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InstantHomeScreen)
